import * as plugins from './smartsocket.plugins.js';

export const logger = new plugins.smartlog.ConsoleLog();
